import { AbstractUploadAdapter } from '../index';

export enum ReaderEvents {
    LOAD = 'load', ERROR = 'error', ABORT = 'abort'
}

export class ImageBase64UploadAdapter extends AbstractUploadAdapter {
    private readonly reader: FileReader = new FileReader();

    private readerEventHandler(event: ProgressEvent<FileReader>, resolve, reject): void {
        switch (event.type) {
            case ReaderEvents.LOAD:
                return resolve({ default: this.reader.result });
            case ReaderEvents.ERROR:
                return reject(this.reader.error);
            case ReaderEvents.ABORT:
                return reject();
        }
    }

    private configureReader(resolve, reject): void {
        const handler = (event): void => this.readerEventHandler(event, resolve, reject);

        [ReaderEvents.ABORT, ReaderEvents.ERROR, ReaderEvents.LOAD]
            .forEach(eventType => this.reader.addEventListener(eventType, handler, false));
    }

    private async readFile(file: Blob): Promise<{default: string | ArrayBuffer}> {
        return new Promise((resolve, reject) => {
            this.configureReader(resolve, reject);
            this.reader.readAsDataURL(file);
        });
    }

    constructor(loader) {
        super(loader);
    }

    public async upload(): Promise<{default: string | ArrayBuffer}> {
        try {
            const file = await this.loader.file;
            return this.readFile(file);
        } catch (e) {
            await this.abort();
        }
    }

    public async abort(): Promise<void> {
        this.reader.abort();
    }
}
